import script from "./CharacterOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterOptions.vue?vue&type=script&setup=true&lang=js"

import "./CharacterOptions.vue?vue&type=style&index=0&id=6a0a720a&lang=css"

const __exports__ = script;

export default __exports__